<template>
  <section>
    <ul>
      <li :class='[nav.selected?"seleccted":""]' v-for="(nav,index) in currentNavigationList" :key="nav.path" >
          <span  @click="onNavBtn(nav)">{{ nav.name }}</span>
        <img src="../../../assets/images/error.png" @click="onCloseBtn(nav)"/>
        <span class="gap" v-if="!(currentNavigationList[index+1]&&currentNavigationList[index+1].selected)"></span>
      </li>
      <li class="nav-more" v-if="navigationList.length>10" @click="onMoreBtn">...</li>
    </ul>
    
  </section>
</template>
<script>
import { mapState, mapMutations,mapGetters } from "vuex";
export default {
  name: "BoskTabNavigation",
  data:function(){
  return{
  }
  },
  computed: {
    ...mapState({
      navigationList: (state) => state.tabNavigation.navigationList,
     
    }),
    ...mapGetters('tabNavigation',['currentNavigationList'])
  },
  watch:{
    currentNavigationList:{
      handler:function(newArr,arr){
    
      },
      deep:true,
      immediate: true,
    }
  },
 
  methods: {
    ...mapMutations("tabNavigation", ["delNavigation","selectedNavigation","delFirstNavigation"]),
    onCloseBtn(nav) {
      this.delNavigation(nav);
    },
    onNavBtn(nav) {
      if (this.$route.path === nav.path) return;
      this.selectedNavigation(nav)
      this.$router.push(nav.path);
    },
    onMoreBtn(){
      this.delFirstNavigation();
    }
  },
 
};
</script>
<style scoped>
ul {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background:#333;
  border-bottom:5px solid #666;
  padding-top:5px;

}
li {

  padding:  5px;
  /* border: 1px solid #ccc; */
  /* 
  border-top:1px solid #ccc; */
  /* border-radius: 10px 10px 0 0; */
  box-sizing: border-box;
  /* margin: 5px 0 0 0; */
  display: flex;
  align-items: center;
  cursor: pointer;
  background:#333;
  /* border-radius: 10px; */
  color:white;
  /* border-right:1px solid #666; */
}
img {
  width: 20px;
  height: 20px;
  cursor: pointer;

}
.seleccted{
  /* border-right:1px solid rgba(51, 119, 190, 1);
  border-top:1px solid rgba(51, 119, 190, 1);
  border-left:1px solid rgba(51, 119, 190, 1); */
 
  background:#666;
  border-radius: 10px 10px 0 0;
  /* margin-top:5px; */
}
.nav-more{
  border:none;
}
.gap{
  display:inline-block;
  height:15px;
  width:1px;
  background:#666;
  margin-left:5px;
}
</style>
